module.exports = __webpack_public_path__ + "media/images/logo_transparent_black-24a8608615e64fe9a08a898c25552819.svg";